import { cn } from '@/lib/utils'
import { ChevronRight, Home } from 'lucide-react'
import { BreadcrumbItem } from '../types'
import { truncateText } from '../utils'

interface FinderBreadcrumbsProps {
    items: BreadcrumbItem[]
    onNavigate: (folderId: string | null) => void
}

export function FinderBreadcrumbs({ items, onNavigate }: FinderBreadcrumbsProps) {
    if (items.length <= 1) return null

    return (
        <nav className='flex items-center px-4 py-2 text-sm bg-gray-50/50 border-b border-gray-50 shrink-0'>
            {items.map((item, index) => (
                <div key={item.id ?? 'root'} className='flex items-center'>
                    {index > 0 && <ChevronRight className='mx-1.5 text-[10px] text-gray-300 w-3 h-3' />}
                    <button
                        type='button'
                        onClick={() => onNavigate(item.id)}
                        disabled={index === items.length - 1}
                        className={cn(
                            'flex items-center gap-1 px-1.5 py-0.5 rounded-md transition-colors',
                            index === items.length - 1
                                ? 'text-gray-700 cursor-default'
                                : 'text-gray-400 hover:text-[#63316B] hover:bg-gray-100'
                        )}
                    >
                        {index === 0 && <Home className='w-3 h-3' />}
                        <span className='text-sm'>{truncateText(item.name, 20)}</span>
                    </button>
                </div>
            ))}
        </nav>
    )
}
